// Please note that the redux state is the source of truth for query parameters
// such as slideIndex etc; so chances are you should be getting the paramter
// you want from state, rather than using this function / reading the URL.
export function getNumericParam(search, key, fallback) {
  const params = new URLSearchParams(search);

  if (params.has(key)) {
    const value = parseInt(params.get(key), 10);

    if (!Number.isNaN(value)) {
      return value;
    }
  }

  return fallback ? parseInt(params.get(fallback), 10) || null : null;
}

export const getCurrentURL = () => new URL(window.location.href);

// Identifies Channel URLs. This is a prototype feature that, at the time of
// writing, allows all the decks in a folder to be viewed.
export const isChannel = () => getCurrentURL().pathname.startsWith('/channel/');

// Identifies Public URLs. Currently an unreleased feature that would allow
// users to embed Vizia in web pages etc.
export const isPublic = () => getCurrentURL().pathname.startsWith('/p/');

// Identifies public Tycho endpoints. Since they're public they don't require
// authentication.
export const isPublicEndpoint = path => path.startsWith('/pub/') || path.startsWith('pub/');

// Identifies Private URLs. These are private in that they're restricted to users
// with email addresses that have been whitelisted. When authentication is required
// the user must provide their email address to receive an email invite.
export const isPrivateLink = () => getCurrentURL().pathname.startsWith('/pl/');

// Identifies Invite URLs. These are the URLs used in email invites.
export const isInvite = () => getCurrentURL().pathname.startsWith('/i/');

// Identifies Signage URLs. These are the URLs that can be used with physical
// installations, third-party platforms etc.
export const isSignage = () => getCurrentURL().pathname.startsWith('/s/');
